import { ButtonWithoutWrapper } from 'components/Button';
import React, { ReactNode, useEffect } from 'react';
import { useNavigate, useRouteError } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from 'styles/theme';

interface Props {
  children?: ReactNode;
  errorMessage?: string;
}

const NotFound: React.FC<Props> = ({ children, errorMessage }) => {
  const routeError = useRouteError();
  const navigate = useNavigate();

  const error = routeError || errorMessage;

  useEffect(() => {
    document.title = 'Sidan hittades inte | Remondis';
  }, []);

  if (error) {
    return (
      <Wrapper>
        <ThanksCard>
          <Heading>Oops!</Heading>
          <Subheading>Sidan kunde inte hittas.</Subheading>
        </ThanksCard>

        <BackButton
          onClick={() => {
            document.title = 'Vill du ha offert på återvinning?';
            navigate('/alectafastigheter');
          }}
        >
          Tillbaka
        </BackButton>
      </Wrapper>
    );
  }

  return <>{children}</>;
};

export default NotFound;

const Wrapper = styled.div`
  width: 100dvw;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
`;

const ThanksCard = styled.div`
  width: 100%;
  max-width: 800px;
  min-height: 479px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 40px;
  background-color: ${theme.colors.secondary};
  padding: 1rem;
`;

const BackButton = styled(ButtonWithoutWrapper)`
  max-width: 300px;
`;

const Heading = styled.h1`
  font-family: var(--secondary-font);
  font-size: 3rem;
  font-weight: 400;
  color: #000000;
  margin: 0;
`;

const Subheading = styled.p`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.4);
  line-height: 125%;
  letter-spacing: 0.02px;
  font-size: 1rem;
  margin: 12px 0 0;
`;
